import getApi from '../../api/apisauceConfig'
import { deserializePatientResponse } from './mapper/patients.mapper'
import { ApiPatientResource } from './mapper/patients.model'

export const getPatient = (id: number) =>
  getApi().get<ApiPatientResource>(`/patients/${id}`).then(deserializePatientResponse)
